export default __webpack_public_path__ + "static/media/huifa.26684c1a.svg";